import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NotificationsService } from 'angular2-notifications';

import { Log } from '../../../utils/index';
import { Tracker, BreadcrumbItem, User, Position } from '../../../entities/index';
import { TrackerService } from '../../../services/tracker.service';
import { GEOFENCE_MODES, SOS_MODES } from '../../../services/constants.service';

@Component({
  selector: 'app-tracker-detail',
  templateUrl: './tracker-detail.html'
})
export class TrackerDetailComponent implements OnInit {
  trackerId: number;
  featureToDisplay: string;
  tracker: Tracker = new Tracker();
  geofenceModes: string[] = GEOFENCE_MODES;
  sosModes: string[] = SOS_MODES;
  lastPosition: Position;

  pageTitle = 'Tracker Detail';
  breadcrumbs: BreadcrumbItem[] = [
    new BreadcrumbItem('Tracker List', 'map-marker', '/tracker'),
    new BreadcrumbItem('Tracker Detail', 'map-marker')
  ];

  constructor(protected router: Router,
              protected route: ActivatedRoute,
              protected trackerService: TrackerService,
              protected notification: NotificationsService,
  ) {
    this.trackerId = Number(route.snapshot.params.id);
    this.pageTitle += ' #' + this.trackerId;
    this.breadcrumbs[1].title = this.pageTitle;
  }

  @Log()
  ngOnInit() {
    this.trackerService
      .get(this.trackerId)
      .subscribe(tracker => {
        this.tracker = tracker;
        this.lastPosition = (tracker && tracker.position && tracker.position.length > 0) ? tracker.position[0] : null;
        this.featureToDisplay = this.tracker.features.toString().replace(/,/g, ', ').replace(/_/g, ' ');
      });
  }

  @Log('blue')
  save() {
    this.trackerService
      .save(this.tracker)
      .subscribe(tracker => {
        this.tracker = tracker;
        this.notification.success('SUCCESS', 'The tracker has been updated.');
      });
  }

  @Log('blue')
  removeFromAccount() {
    if (confirm('Are you sure you want to remove this tracker ? This is definitive.')) {
      this.trackerService.remove(this.tracker).subscribe(
        res => {
          this.router.navigate(['/user']);
          this.notification.success('SUCCESS', 'The tracker has been removed.');
        }
      );
    }
  }

  @Log('blue')
  replaceTracker(imei: string) {
    if (!imei) {
      this.notification.error('ERROR', 'Invalid IMEI');
      return;
    }

    this.trackerService.replace(this.tracker.id, imei).subscribe(
      res => {
        this.notification.success('SUCCESS', 'The tracker has been replaced.');
        this.tracker = res;
      }
    );
  }

  @Log('blue')
  transfertTo(user: User) {
    if (confirm(`Are you sure you want to transfer this tracker to user ${user.mail} ?`)) {
      this.trackerService.transfertToUser(this.tracker, user).subscribe(
        tracker => {
          this.tracker = tracker;
          this.notification.success('SUCCESS', 'The tracker has been transfered.');
        }
      );
    }
  }
}



// WEBPACK FOOTER //
// /builds/weenect1/backofficev3/src/app/components/pages/tracker/tracker-detail.component.ts